import { render } from "./Gallery.vue?vue&type=template&id=4c6b057a&scoped=true&ts=true"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"

import "./Gallery.vue?vue&type=style&index=0&id=4c6b057a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6b057a"]])

export default __exports__